module["exports"] = ['ակերտ', 'աշեն', 'աշատ'];